import React, { useState } from 'react'
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'

import { authenticate } from 'UserApp/store/user/actions'
import { getWebDeviceInfo } from 'lib/device-info'
import Layout from 'components/Layout/SplitLayout'
import {
  Text,
  Link,
  Header,
  Input,
  Loader,
  Label,
  Checkbox,
  Button,
  PasswordInput,
  FieldGroup,
  Fields,
} from '@pet-notify/ui'
import style from './style.module.scss'

function SigninScreen() {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string>()
  const { register, handleSubmit } = useForm()

  const onSubmit = handleSubmit(async (data) => {
    setIsLoading(true)
    try {
      const deviceInfo = getWebDeviceInfo()

      await dispatch(
        authenticate({
          ...data,
          ...(deviceInfo ? { device_info: deviceInfo } : {}),
        }),
      )
      history.push(location.state?.originalPath || '/')
    } catch (error) {
      if (error instanceof Error) {
        setError(error.message)
      }
    } finally {
      setIsLoading(false)
    }
  })

  return (
    <Layout alternateBackground2>
      <Header as='h1' size='xxlarge' mb='8'>
        Sign in
      </Header>

      <form onSubmit={onSubmit} className='mb-8'>
        <Fields>
          <FieldGroup>
            <Label htmlFor='signin-email'>Email</Label>
            <Input type='email' id='signin-email' {...register('email')} />
          </FieldGroup>

          <FieldGroup>
            <Label htmlFor='signin-password'>Password</Label>
            <PasswordInput id='signin-password' {...register('password')} />
          </FieldGroup>

          <FieldGroup>
            <Checkbox
              label='Keep me logged in'
              id='signin-keep-me-signed-in'
              {...register('keepMeSignedIn')}
            />
          </FieldGroup>

          {error && <Text variant='error'>{error}</Text>}
        </Fields>

        {isLoading ? <Loader /> : <Button type='submit'>Sign in</Button>}
        <Button type='submit' onClick={() => history.push('/signup')} disabled={isLoading} style={{marginLeft: '16px'}}>Create account</Button>
      </form>

      <ul className='links'>
        <li>
          <Link as={RouterLink} to='/forgot-password'>
            Forgot Password?
          </Link>
        </li>
        <li>
          <Link as={RouterLink} to='/forgot-email'>
            Forgot Email?
          </Link>
        </li>
        <li>
          <a href='/activate/2' className={style.alreadyPurchased}>
            Already purchased an Intellitag?
          </a>
        </li>
      </ul>
    </Layout>
  )
}

export default SigninScreen
